class ValidationError extends Error {
    constructor(err) {
        super(err.message);
        this.errors = err.errors;
    }
}

export default ValidationError;